// import { DateTimeInput as RADateInput } from "react-admin";
import { DateTimeInput } from './DateTimeInput';
export default DateTimeInput;
